import { render, staticRenderFns } from "./WalletHolidayNotice.vue?vue&type=template&id=6f59ef44&"
import script from "./WalletHolidayNotice.vue?vue&type=script&lang=js&"
export * from "./WalletHolidayNotice.vue?vue&type=script&lang=js&"
import style0 from "./WalletHolidayNotice.vue?vue&type=style&index=0&id=6f59ef44&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports